import { MouseEventHandler } from "react";
import "./AlertComponent.scss";
import { Alert, Typography, Stack } from "@mui/material";

interface AlertComponentProps {
  success?: boolean;
  children?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  hideCloseIcon?: boolean;
  removeMargin?: boolean;
}
export const AlertComponent = ({
  success,
  children,
  onClick,
  hideCloseIcon = false,
  removeMargin = false,
}: AlertComponentProps) => {
  return (
    <>
      <Stack width="100%" justifyContent="space-between">
        <Alert
          icon={false}
          severity={`${success ? "success" : "error"}`}
          className={`${success ? "success" : "error"} alertdiv ${
            removeMargin && "remove-margin"
          }`}
        >
          <Stack direction="row" gap="0.5rem" width="100%">
            <span
              className={`${
                success ? "t-icon-check" : "t-icon-CGU"
              } alert-icon`}
            />
            <Typography>{children}</Typography>
            {!hideCloseIcon && (
              <span
                onClick={onClick}
                className={`${!success && "d-none"} t-icon-close alert-icon`}
              />
            )}
          </Stack>
        </Alert>
      </Stack>
    </>
  );
};

export default AlertComponent;
